module.exports = __webpack_public_path__ + "static/img/img-kf3.fe639a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-kf3.png
// module id = fsUe
// module chunks = 0